<template>
  <page title="indicator-light">
    <div class="item">
      <div class="item-header" @click="toggleDetails(0)">
        <div>1.</div>
        <div class="icon-0" >
          <div class="i-c-0">
            <img src="../../assets/imgs/icon_light_blue.png" />
          </div>
          <div class="i-c-0">
            <img src="../../assets/imgs/icon_transfer_blue.png" />
          </div>
          <div class="i-c-0">
            <img src="../../assets/imgs/icon_wifi_blue.png" />
          </div>

        </div>
        <div class="tip">{{i18n.Lights}}</div>
        <div class="arrow" >
          <img v-if="items[0].expanded" src="../../assets/imgs/down.png" />
          <img v-else src="../../assets/imgs/right.png" />
        </div>
      </div>
      <div v-if="items[0].expanded" class="item-details">
        <p>{{i18n.reason}}: {{i18n.rt0}}</p>
        <p>{{i18n.solution}} /</p>
      </div>
    </div>

    <div class="item">
      <div class="item-header" @click="toggleDetails(1)">
        <div>2.</div>
        <div class="icon">
          <div class="i-c">
            <img src="../../assets/imgs/icon_light_gray.png" />
            <span >white</span>
          </div>
          <div class="i-c">
            <img src="../../assets/imgs/icon_transfer_gray.png" />
            <span >white</span>
          </div>
          <div class="i-c">
            <img src="../../assets/imgs/icon_wifi_gray.png" />
            <span >white</span>
          </div>
        </div>
        <div class="arrow" >
          <img v-if="items[1].expanded" src="../../assets/imgs/down.png" />
          <img v-else src="../../assets/imgs/right.png" />
        </div>
      </div>
      <div v-if="items[1].expanded" class="item-details">
        <p>{{i18n.reason}} MIFI function being turned on</p>
        <p>{{i18n.solution}} /</p>
      </div>
    </div>
    <div class="item">
      <div class="item-header" @click="toggleDetails(2)">
        <div>3.</div>
        <div class="icon">
          <div class="i-c">
            <img src="../../assets/imgs/icon_light_gray.png" />
            <span >red</span>
          </div>
          <div class="i-c">
            <img src="../../assets/imgs/icon_transfer_gray.png" />
            <span >white</span>
          </div>
          <div class="i-c">
            <img src="../../assets/imgs/icon_wifi_gray.png" />
            <span >white</span>
          </div>
        </div>
        <div class="arrow" >
          <img v-if="items[2].expanded" src="../../assets/imgs/down.png" />
          <img v-else src="../../assets/imgs/right.png" />
        </div>
      </div>
      <div v-if="items[2].expanded" class="item-details">
        <p>{{i18n.reason}}</p>
        <p>{{i18n.rt1}}</p>
        <p>{{i18n.rt2}}</p>
        <p>{{i18n.rt3}}</p>
        <p>{{i18n.solution}} </p>
        <p>{{i18n.st1}}</p>
        <p>{{i18n.st2}}</p>
        <p>{{i18n.st3}}</p>
      </div>
    </div>
    <div class="item">
      <div class="item-header" @click="toggleDetails(3)">
        <div>4.</div>
        <div class="icon">
          <div class="i-c">
            <img src="../../assets/imgs/icon_light_gray.png" />
            <span >white</span>
          </div>
          <div class="i-c">
            <img src="../../assets/imgs/icon_transfer_gray.png" />
            <span >red</span>
          </div>
          <div class="i-c">
            <img src="../../assets/imgs/icon_wifi_gray.png" />
            <span >white</span>
          </div>
        </div>
        <div class="arrow" >
          <img v-if="items[3].expanded" src="../../assets/imgs/down.png" />
          <img v-else src="../../assets/imgs/right.png" />
        </div>
      </div>
      <div v-if="items[3].expanded" class="item-details">
        <p>{{i18n.reason}} {{i18n.t1}}</p>
        <p>{{i18n.solution}} {{i18n.t2}}</p>
      </div>
    </div>
    <div class="item">
      <div class="item-header" @click="toggleDetails(4)">
5        <div class="icon">
          <div class="i-c">
            <img src="../../assets/imgs/icon_light_gray.png" />
            <span >red</span>
          </div>
          <div class="i-c">
            <img src="../../assets/imgs/icon_transfer_gray.png" />
            <span >red</span>
          </div>
          <div class="i-c">
            <img src="../../assets/imgs/icon_wifi_gray.png" />
            <span >white</span>
          </div>
        </div>
        <div class="arrow" >
          <img v-if="items[4].expanded" src="../../assets/imgs/down.png" />
          <img v-else src="../../assets/imgs/right.png" />
        </div>
      </div>
      <div v-if="items[4].expanded" class="item-details">
        <p>{{i18n.reason}} {{i18n.t4}}</p>
        <p>{{i18n.solution}} {{i18n.t5}}</p>
      </div>
    </div>
    <div class="item">
      <div class="item-header" @click="toggleDetails(5)">
        <div>6.</div>
        <div class="icon">
          <div class="i-c">
            <img src="../../assets/imgs/icon_light_gray.png" />
            <span >red</span>
          </div>
          <div class="i-c">
            <img src="../../assets/imgs/icon_transfer_gray.png" />
            <span >red</span>
          </div>
          <div class="i-c">
            <img src="../../assets/imgs/icon_wifi_gray.png" />
            <span >red</span>
          </div>
        </div>
        <div class="arrow" >
          <img v-if="items[5].expanded" src="../../assets/imgs/down.png" />
          <img v-else src="../../assets/imgs/right.png" />
        </div>
      </div>
      <div v-if="items[5].expanded" class="item-details">
        <p>{{i18n.reason}}{{i18n.t6}}</p>
        <p>{{i18n.solution}} {{i18n.t7}}</p>
      </div>
    </div>
  </page>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          expanded: true
        },
        {
          expanded: false
        },
        {
          expanded: false
        },
        {
          expanded: false
        },
        {
          expanded: false
        },
        {
          expanded: false
        }
      ]
    };
  },
  methods: {
    toggleDetails(index) {
      this.items[index].expanded = !this.items[index].expanded;
    }
  },
  computed: {
    i18n () {
      return this.$t('help')
    }
  }
};
</script>

<style scoped>
.indicator-light {
  padding: 20px;
}

.item {
  border: 1px solid #ccc;
  margin-bottom: 10px;
  border-radius: 5px;
  margin: 12px;
  border-radius: 10px;
  padding: 15px;
}

.item-header {
  display: flex;
  padding: 10px;
  cursor: pointer;
}
.item-header span{
  padding: 10px;
}
.icon-0{
  display: flex;
  margin: 0 5px;
  width: 30%;
}
.icon-0 img{
  width: 35px;
  height: 35px;
  padding-right: 10px;
  padding-left: 10px;
}
.icon {
  display: flex;
  margin: 0 5px;
  width: 90%;
}
.i-c{
  width: 250px;
}
.i-c-0{
  width: 60px;
}
.tip{
  width: 70%;
  color: #036EB8;
}
.icon img {
  width: 35px;
  height: 35px;
  padding-right: 10px;
  padding-left: 10px;
}

.item-details {
  padding: 10px;
  background-color: #f9f9f9;
}
.arrow img{
  width: 30px;
  height: 30px;
}
</style>
